import { getErrorMessage } from "./api-client";

/**
 * Mirrors SUBSCRIPTION_REQUIRED_DETAIL in the backend's dependencies.py. The
 * axios interceptor branches on this exact string to redirect to /pricing, so
 * the two must change together — an iteration-limit 403 deliberately uses a
 * different string and must not navigate.
 */
export const SUBSCRIPTION_REQUIRED_DETAIL = "Active subscription required";

export type AsyncError = {
  message: string;
  cause?: unknown;
  /** HTTP status when the failure came from a response (e.g. a stream that
   *  failed to open), so callers can react to 403s without parsing text. */
  status?: number;
} | null;

export function toAsyncError(err: unknown): AsyncError {
  if (err == null) return null;
  const status =
    typeof err === "object" && "status" in err && typeof err.status === "number"
      ? err.status
      : undefined;
  return { message: getErrorMessage(err), cause: err, status };
}
